function App() {
  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: 20 }}>
      <h1>Privacy Policy - Germany for Arabs</h1>

      <p>
        This app does not collect, store, or share personal data.
      </p>

      <p>
        We may use third-party services such as Google AdMob and Firebase in the future.
        These services may collect anonymous usage data to improve the app.
      </p>

      <p>
        We respect your privacy and do not sell or misuse any data.
      </p>

      <h3>Contact</h3>
      <p>Contact us: mohamedrxo4@gmail.com</p>
    </div>
  );
}

export default App;